module.exports = __webpack_public_path__ + "img/2.6d4f8760.png";